module.exports = __webpack_public_path__ + "img/Frame 1321314580.16f443f2.png";